import React from "react"
import {get} from "lodash"
import PropTypes from "prop-types"
import {withRouter} from "react-router-dom"

import {Label} from "@irati/ui/src/Typography"
import {FormattedMessage} from "@irati/utils/lang"

const SagaStep = ({location, saga}) => (
  <Label color="subdued" uppercase>
    <FormattedMessage id="perks.components.productForms.sagaStep.step" />
    {saga ? saga.currentStep : get(location, "state.saga.currentStep")}
    <FormattedMessage id="perks.components.productForms.sagaStep.of" />
    {saga ? saga.totalSteps : get(location, "state.saga.totalSteps")}
  </Label>
)

SagaStep.defaultProps = {
  location: {},
  saga: null
}
SagaStep.propTypes = {
  location: PropTypes.object,
  saga: PropTypes.object
}

export default withRouter(SagaStep)
